"use client"
import { Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { UserIcon } from "@/icons/solid"
import { Mail } from "react-feather"
import { MetadataSectionContainer } from "./MetadataSectionContainer"
import { PersonalDetailCard } from "./PersonalDetailCard"

const RepresentationSectionFragment = graphql(`
  fragment RepresentationSection on Creative {
    id
    name
    representations {
      edges {
        cursor
        node {
          id
          name
          avatar80w: avatarUrl(width: 80)
          avatarInitials
          entityName
          agentName
          agentEmail
          creative {
            id
            handle
          }
        }
      }
    }
  }
`)

interface Props {
  creative: FragmentType<typeof RepresentationSectionFragment> | null | undefined
  upsellSubscription: boolean
  openProModal: () => void
}

const RightElement: React.FC<{ agentEmail: string | undefined | null }> = ({ agentEmail }) => {
  if (!agentEmail) {
    return null
  }
  return (
    <div className="pr-3">
      <Mail size={20} />
    </div>
  )
}

const RedactedRepresentation = ({ openProModal }: { openProModal: () => void }) => {
  return (
    <div onClick={openProModal} className="flex cursor-pointer flex-row items-center gap-x-3">
      <div className="flex size-12 items-center justify-center rounded-sm bg-bg-3">
        <UserIcon className="size-5 fill-bg-5" />
      </div>
      <Text>Representation</Text>
    </div>
  )
}

export const RepresentationSection: React.FC<Props> = ({ openProModal, ...props }) => {
  const creative = useFragment(RepresentationSectionFragment, props.creative)

  return (
    <MetadataSectionContainer
      title="Representation"
      upsellSubscription={props.upsellSubscription}
      openProModal={openProModal}
      creativeName={creative?.name.split(" ")[0]}>
      <div className="flex w-full flex-col gap-2">
        {creative?.representations?.edges?.map(edge => {
          const node = edge?.node
          if (props.upsellSubscription) {
            return <RedactedRepresentation key={node?.id} openProModal={openProModal} />
          }
          const rightElement = <RightElement agentEmail={node?.agentEmail} />
          return (
            <div key={node?.id} className="flex w-full flex-row items-center">
              <PersonalDetailCard
                name={node?.agentName}
                avatarInitials={node?.avatarInitials}
                avatar80w={node?.avatar80w}
                subtext={node?.name}
                link={`mailto:${node?.agentEmail}`}
                RightElement={rightElement}
              />
            </div>
          )
        })}
      </div>
    </MetadataSectionContainer>
  )
}
